import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Dialog, Divider, Grid, IconButton, Typography } from "@mui/material";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { color } from "../../../StyleData/Config";
import NormalTable from "../../../Component/NormalTable";
import { Clear, Visibility, PrintOutlined } from "@mui/icons-material";
import { printReservationForm } from "../../../Component/printWorkOrder";
import { usePrintLoader } from "../../../Component/usePrintLoader";

const PartsReservation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);

  const [viewDialogue, setViewDialogue] = useState(false);
  const [viewItems, setViewItems] = useState([]);
  const [viewCode, setViewCode] = useState("");
  const { runPrint, PrintLoader } = usePrintLoader();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const link = masterAPI["partsReservation"]?.link;

    try {
      const res = await axiosPrivate.get(`${link}`);
      if (res.data.result) {
        res.data.result.sort((a, b) =>
          (b.code || "").localeCompare(a.code || "", undefined, {
            numeric: true,
            sensitivity: "base",
          }),
        );
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter((fil) => fil.isActive);
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
      }
    } catch (e) {
      console.log(e, "parts reservation");
      setData([]);
      setBackUpData([]);
    }

    setIsLoading(false);
  };

  const handleCodeClick = (row) => {
    setViewItems(row.partsReservationItemsList || []);
    setViewCode(row.code);
    setViewDialogue(true);
  };

  const itemColumns = [
    {
      Header: "Part Code",
      accessor: "partCode",
    },
    {
      Header: "Part Name",
      accessor: "partName",
    },
    {
      Header: "Stock Room",
      accessor: "stockRoomName",
    },
    {
      Header: "Quantity",
      accessor: "quantity",
    },
  ];

  const columns = [
    {
      Header: "Code",
      accessor: "code",
      Cell: ({ row }) => (
        <Typography
          sx={{
            color: "#0d6efd",
            fontSize: "inherit",
            fontWeight: 600,
            cursor: "pointer",
          }}
          onClick={() => handleCodeClick(row.original)}
        >
          {row.original.code}
        </Typography>
      ),
    },
    {
      Header: "Work Order Code",
      accessor: "workOrderCode",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Remarks",
      accessor: "comments",
      Cell: ({ row }) =>
        row.original.status?.toUpperCase() === "REJT"
          ? row.original.comments || "---"
          : "---",
    },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <Box sx={{ whiteSpace: "nowrap" }}>
          <IconButton
            title="Print Reservation"
            onClick={() =>
              runPrint(
                printReservationForm,
             row.original.id,
             row.original.code+" - "+"Reservation"
              )

            }
          >
            <PrintOutlined
              sx={{
                fontSize: color.masterEditDelButton,
                color: color.masterEditDelButtonColor,
              }}
            />
          </IconButton>
        </Box>
      ),
    },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);
      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          Parts Reservation
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
        loading={isLoading}
        buttonDisable={true}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
      />

      <Dialog
        open={viewDialogue}
        onClose={() => setViewDialogue(false)}
        fullWidth
        maxWidth={"md"}
      >
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: "0.5rem",
            }}
          >
            <Typography
              sx={{
                color: color.masterDialogTitleColor,
                fontSize: color.masterDialogFontSize,
              }}
            >
              Part List {viewCode ? `- ${viewCode}` : ""}
            </Typography>
            <IconButton onClick={() => setViewDialogue(false)}>
              <Clear />
            </IconButton>
          </Box>
          <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
          <NormalTable columns={itemColumns} data={viewItems} />
        </Box>
      </Dialog>
      {PrintLoader}
    </>
  );
};

export default PartsReservation;
